/* eslint-disable camelcase */
export const pt_br = {
    values: {
        Home: 'Início',
        'Home Page': 'Página Inicial'
    }
}
